import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { AssessmentProvider } from './context/AssessmentContext';
import LandingPage from './pages/LandingPage';
import ContactPage from './pages/ContactPage';
import AssessmentPage from './pages/AssessmentPage';
import ResultsPage from './pages/ResultsPage';

/**
 * AssessmentModule - Main component for the PMO Maturity Assessment tool
 * Provides routing and context for the assessment flow
 */
const AssessmentModule = () => {
  return (
    <AssessmentProvider>
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/:assessmentId/question/:questionIndex" element={<AssessmentPage />} />
        <Route path="/results/:assessmentId" element={<ResultsPage />} />
        <Route path="/results" element={<ResultsPage />} />
      </Routes>
    </AssessmentProvider>
  );
};

export default AssessmentModule;
